import TaxStateBracketsPage from '@playground/features/dictionary/TaxStateBracketsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/_superAdmin/dictionary/tax-state-brackets'
)({
  component: TaxStateBracketsPage,
})
